import { useStore } from "vuex";
import { ObjectTypes, OperationTypes } from "@/utils/utils";
import { ToggleStudentMediaDevicesAsync, ToggleStudentPaletteAsync } from "@/services";
import { MODULES, vuexName } from "@/store/utils";

export interface CanvasObjectModel {
  id: string;
  type?: ObjectTypes;
  operation: OperationTypes;
  metadata?: string;
}

export interface ZoomSlideModel {
  ratio: number;
  position: ZoomSlidePositionModel;
}

export interface ZoomSlidePositionModel {
  x: number;
  y: number;
  viewPortX?: number;
  viewPortY?: number;
}

export const useRemoteRequests = () => {
  const { dispatch } = useStore();

  const dispatchAsync = async (action: string, payload: any) => {
    await dispatch(`teacherRoom/${action}`, payload);
  };

  return {
    requestUpdateCanvasObject: (payload: CanvasObjectModel) =>
      dispatchAsync(vuexName(MODULES.TEACHER_ROOM.DISPATCHES.REQUEST_UPDATE_CANVAS_OBJECT_ASYNC, false), payload),

    broadcastMessageUpdateCanvasObject: (payload: CanvasObjectModel) =>
      dispatchAsync(vuexName(MODULES.TEACHER_ROOM.DISPATCHES.BROADCAST_MESSAGE_UPDATE_CANVAS_OBJECT, false), payload),

    requestToggleStudentMediaDevices: (payload: ToggleStudentMediaDevicesAsync) =>
      dispatchAsync(vuexName(MODULES.TEACHER_ROOM.DISPATCHES.TOGGLE_STUDENT_MEDIA_DEVICES_ASYNC, false), payload),

    requestToggleStudentPalette: (payload: ToggleStudentPaletteAsync) =>
      dispatchAsync(vuexName(MODULES.TEACHER_ROOM.DISPATCHES.TOGGLE_STUDENT_PALETTE_ASYNC, false), payload),

    requestSetStudentsBadge: (payload: string[]) => dispatchAsync(vuexName(MODULES.TEACHER_ROOM.DISPATCHES.SET_STUDENTS_BADGE_ASYNC, false), payload),

    requestClearStudentRaisingHand: (studentId: string) =>
      dispatchAsync(vuexName(MODULES.TEACHER_ROOM.DISPATCHES.CLEAR_STUDENT_RAISING_HAND_ASYNC, false), studentId),

    requestZoomSlide: (payload: ZoomSlideModel) => dispatchAsync(vuexName(MODULES.TEACHER_ROOM.DISPATCHES.UPDATE_ZOOM_SLIDE, false), payload),

    requestMoveZoomedSlide: (payload: ZoomSlidePositionModel) =>
      dispatchAsync(vuexName(MODULES.TEACHER_ROOM.DISPATCHES.SET_MOVE_ZOOMED_SLIDE, false), { position: payload }),
  };
};
